export default "! 1-cent\n!\nEach step = 1 cent (1200edo).\n1\n!\n1.0\n"